<div
    class="hot-toast-loader-icon"
    [ngStyle]="{ 'border-color': theme()?.primary, 'border-right-color': theme()?.secondary }"></div>
